<template>
  <div class="py-7 px-5 min-h-screen sign-up-bg w-full">
    <shipblu-card class="card p-10 xl:w-1/2 md:w-3/4 m-auto">
    <button v-if="nextStep" @click="nextStep = false" class="btn h-9 flex items-center">
      <feather-icon
        icon="ArrowLeftIcon"
        svgClasses="h-5 w-5"
      />
    </button>
      <div class="flex justify-center mb-10">
        <h1 class="font-semibold">{{$t('Sign Up')}}</h1>
      </div>
      <user-sign-up :merchant="merchant" @merchant="merchant = $event"></user-sign-up>
      <div class="mt-6 flex justify-center m-auto">
      </div> 
    </shipblu-card>
  </div>
</template>

<script>
import {sendRequest} from '../../../http/axios/requestHelper'
import vSelect from 'vue-select'
import ShipbluCard from '../../../layouts/components/ShipbluCard.vue'
import UserSignUp from './UserSignUp.vue'

export default {
  data () {
    return {
      pinModal: false,
      errorMessage: '',
      pinValue: '',
      successPin: '',
      governorates: [],
      cities: [],
      zones: [],
      nextStep: false,
      merchant: {
        password: '',
        address: {
          line_3: '',
          line_1: '',
          line_2: '',
          zone: ''
        }
      }
    }
  },
  watch: {
    successPin (val) {
      if (val === true) {
        this.pinModal = false
        this.errorMessage = ''
        this.payoutModal = false
      }
    },
    pinModal (val) {
      if (val === true) {
        this.errorMessage = ''
      }
    }
  },
  methods: {
    nextPage () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$validator.pause()

          this.nextStep = true
          this.$validator.resume()
        }
      })
    },
    loadGovernorates () {
      sendRequest(false, false, this, 'api/v1/magic/geo/governorates/', 'get', null, false,
        (response) => {
          this.governorates = response.data.filter(item => item.id !== 11 || item.id !== 12 || item.id !== 21 || item.id !== 22 || item.id !== 23)
        }
      )
    },
    loadCities (governorateID) {
      const url = 'api/v1/magic/geo/governorates/'
      const type = '/cities/'
      sendRequest(false, false, this, `${url}${governorateID}${type}`, 'get', null, false,
        (response) => {
          this.cities = response.data
        }
      )
    },
    loadZones (cityID) {
      const url = 'api/v1/magic/geo/cities/'
      const type = '/zones/'
      sendRequest(false, false, this, `${url}${cityID}${type}`, 'get', null, false,
        (response) => {
          this.zones = response.data
        }
      )
    }
  },
  components: {
    vSelect,
    ShipbluCard,
    UserSignUp
  },
  created () {
    localStorage.setItem('locale', this.$route.params.lang)
    this.$cookies.set('language', this.$route.params.lang)
    if (this.$route.params.lang === 'en' || this.$cookies.get('language') === 'en') {
      this.$i18n.locale = 'en'
      this.$vs.rtl = false
    } else {
      this.$i18n.locale = 'ar'
      this.$vs.rtl = true
    }
    this.loadGovernorates()
  }
}
</script>
<style lang="scss">
.show-modal {
  visibility: visible;
  opacity: 1 !important;
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: rgba(10, 50, 102, 0.24);
  backdrop-filter: blur(2px);
  opacity: 0;
  transition: all 0.3s ease;
}
.sign-up-bg {
    direction: ltr;
    background-image: url('https://staging-publicstorage1123538a-1p8k71zpb6h3c.s3.eu-west-3.amazonaws.com/bg1.svg');
    inset: 0;
    background-size: cover;
    overflow-y: auto;
    display: grid;
}
.btn {
  padding: 8px;
  border: none;
  color:#6C84A3;
  border-radius: 4px;
  cursor: pointer;
  line-height: 18px;
} 
.disable-btn {
  background: #F1F3F6;
  color: #6C84A3;
}
.active-btn {
  color: #fff;
  font-weight: 500;
  background: #1C5BFE;
  box-shadow: 0px 2px 8px rgba(10, 50, 102, 0.32);
}

.card {
  position: relative;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 3px rgba(28, 91, 254, 0.25);
  border-radius: 25px;
  max-width: 800px;
  padding: 50px;
  margin: auto;
}
</style>